import { useSelector } from 'react-redux';
import { getPopupsSelector } from '@store/popups/popups.selectors';
import { PopupComponent } from './popup.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Popups = function Popups() {
  var popups = useSelector(getPopupsSelector);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: popups === null || popups === void 0 ? void 0 : popups.map(function (popup) {
      return /*#__PURE__*/_jsx(PopupComponent, {
        popupId: popup.popupId
      }, popup.popupId);
    })
  });
};

export { Popups };